import { useMemo } from "react";
import type { SearchResult } from "../api";
import type { ReaderWorkspace } from "../reader/reader-workspace";
import { BookDetailDialog } from "../shelf/book-detail-dialog";
import { createSearchResultDetailItem, findSearchResultShelfItem } from "./search-result-detail";

export function SearchResultDetailDialog({
  result,
  workspace,
  onClose,
}: {
  result: SearchResult;
  workspace: ReaderWorkspace;
  onClose: () => void;
}) {
  const shelfItem = useMemo(() => findSearchResultShelfItem(result, workspace.bookshelf), [result, workspace.bookshelf]);
  const inShelf = Boolean(shelfItem);
  const detailItem = useMemo(
    () => shelfItem ?? createSearchResultDetailItem(result, workspace.selectedSourceByBook[result.book.id]),
    [result, shelfItem, workspace.selectedSourceByBook],
  );
  const selectedBookId = shelfItem?.book.id ?? result.book.id;

  return (
    <BookDetailDialog
      item={detailItem}
      sources={workspace.sources}
      selectedSourceByBook={workspace.selectedSourceByBook}
      onClose={onClose}
      onOpen={chapterId => {
        onClose();
        void workspace.handleOpen(shelfItem ?? result, chapterId);
      }}
      onSourceChange={sourceId => workspace.handleSourceSelect(selectedBookId, sourceId)}
      onSecondaryAction={async () => {
        if (shelfItem) {
          await workspace.handleRemoveSearchResultFromShelf(shelfItem.book.id);
          return;
        }

        await workspace.handleAddSearchResultToShelf(result);
      }}
      onMoveGroup={groupId => shelfItem ? workspace.handleMoveBookToGroup(shelfItem.book.id, groupId) : Promise.resolve()}
      secondaryActionLabel={inShelf ? "删除书籍" : "添加书架"}
      secondaryActionVariant={inShelf ? "destructive" : "secondary"}
    />
  );
}
